// Auto-generated by forge/extract-bytecodes.ts — DO NOT EDIT
// Source: forge/out/MockERC20.sol/MockERC20.json

export const MOCK_ERC20_ABI = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "name_",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "symbol_",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "decimals_",
        "type": "uint8",
        "internalType": "uint8"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "allowance",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "approve",
    "inputs": [
      {
        "name": "spender",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "amount",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "balanceOf",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "burn",
    "inputs": [
      {
        "name": "amount",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "decimals",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint8",
        "internalType": "uint8"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "mint",
    "inputs": [
      {
        "name": "to",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "amount",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "name",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "string",
        "internalType": "string"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "symbol",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "string",
        "internalType": "string"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "totalSupply",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "transfer",
    "inputs": [
      {
        "name": "to",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "amount",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "transferFrom",
    "inputs": [
      {
        "name": "from",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "to",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "amount",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "event",
    "name": "Approval",
    "inputs": [
      {
        "name": "owner",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "spender",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "value",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Transfer",
    "inputs": [
      {
        "name": "from",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "to",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "value",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  }
] as const;

export const MOCK_ERC20_BYTECODE = "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" as const;
